<template>
  <section>
    <!--3d单车-->
    <div
      id="full-360-car"
      class="dlrLayer-iframe"
      v-show="threeDimensionCar.show"
    >
      <iframe
        ref="full-360-car"
        v-if="threeDimensionCar.show"
        :src="carUrl"
        frameborder="0"
        scrolling="no"
        :width="fullFrame.width"
        :height="fullFrame.height"
        border="0"
        allowtransparency="true"
      />
    </div>
    <ShareTip></ShareTip>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import config from '../../config';
import ShareTip from '../ShareTip';
import { URLService } from '../../services/url.service';
export default {
  props: {
    seriesId: {
      type: Number,
      required: true
    }
  },
  components: {
    ShareTip
  },
  computed: {
    ...mapGetters({
      'threeDimensionCar': 'frame/threeDimensionCar',
      'fullFrame': 'frame/fullFrame',
      baseInfo: 'baseInfo',
      phoneCallStatus: 'phoneCall/phoneCallStatus'
    }),
    dealerId () {
      return this.baseInfo.dealerId;
    },
    carUrl () {
      let busi = 'vr4s';
      if (this.phoneCallStatus === 1) {
        busi = 'vr4sRealtime';
      }
      const eid = '2|1211004|72|102|203475|301135|20191115004';
      let carUrl = `${config.car3d}/car/818/car.html?seriesId=${this.seriesId}&busi=${busi}&nojump=1&notrim=1`;
      const frompvareaid = this.$queryParams.pvAreaId;
      const urlSerivce = new URLService(carUrl);
      const dealerId = this.dealerId;
      urlSerivce.queryParams
        .append('dealerId', dealerId)
        .append('eid', eid)
        .append('pvareaid', 2594194)
        .append('frompvareaid', frompvareaid);
      const targetUrl = urlSerivce.build();
      return targetUrl;
    }
  },
  mounted () {
    const self = this;
    const handler = function (event) {
      if (event.target.tagName === 'input') {
        var carFrame = self.$refs['full-360-car'];
        if (carFrame) {
          carFrame.contentWindow.postMessage('inputblur', '*');
        }
      }
    };
    document.addEventListener('focusout', handler);
  },
};
</script>
